import React, { Component } from 'react'
import Modal from "react-bootstrap/Modal";
import './studentDetails.css'

class StudentDetails extends Component {


    render() {

        const user = this.props.user
        return (
            <div>


                <div className="container">

                    <div className="form-item">
                        <h4 className="form">{user && user.addmissiontype}  Addmission Form</h4>
                        <div class="form-row mb-4">
                            <div class="col">
                                <p>Name: <span>{user && user.name}</span></p>
                                <p>Father's Name: <span>{user && user.f_name}</span></p>
                                <p>Mother's Name: <span>{user && user.m_name}</span></p>
                                <p>Birth Date: <span>{user && user.b_day}</span></p>
                            </div>
                            <div class="col" >
                                <img src={user && user.user_pic} height="150" width="150" style={{ marginLeft: '45%' }}></img>
                            </div>
                        </div>
                        <div class="form-row mb-4">
                            <div class="col">
                                <p>Nationality: <span>{user && user.nationality}</span></p>
                            </div>
                            <div class="col">
                                <p>Occopation: <span>{user && user.occopation}</span></p>
                            </div>
                        </div>

                        <div class="form-row mb-4">
                            <div class="col">
                                <p>Present Address: <span>{user && user.address}</span></p>
                            </div>
                        </div>

                        <label htmlFor="number">Contact info:</label>

                        <div class="form-row mb-4">
                            <div class="col">
                                <p>Tell: <span>{user && user.tel}</span></p>
                            </div>
                            <div class="col">
                                <p>Cell: <span>{user && user.cell}</span></p>
                            </div>
                        </div>

                        <div class="form-row mb-4">
                            <div class="col">
                                <p>Email: <span>{user && user.email}</span></p>
                            </div>
                        </div>


                        <div class="form-row mb-4">
                            <div class="col">
                                <p>Permanent Address: <span>{user && user.p_address}</span></p>
                            </div>
                        </div>

                        <label htmlFor="number">Academic Qualification</label><br />
                        <label htmlFor="address">SSC/Equavilant:</label><br />
                        <div class="form-row mb-4">
                            <div class="col">
                                <p>Passing Year: <span>{user && user.ssc_p_year}</span></p>
                            </div>
                            <div class="col">
                                <p>Institute: <span>{user && user.ssc_institute}</span></p>
                            </div>
                            <div class="col">
                                <p>GPA: <span>{user && user.ssc_gpa}</span></p>
                            </div>
                        </div>
                        <label htmlFor="address">HSC/Equavilant:</label><br />
                        <div class="form-row mb-4">
                            <div class="col">
                                <p>Passing Year: <span>{user && user.hsc_p_year}</span></p>
                            </div>
                            <div class="col">
                                <p>Institute: <span>{user && user.hsc_institute}</span></p>
                            </div>
                            <div class="col">
                                <p>GPA: <span>{user && user.hsc_gpa}</span></p>
                            </div>
                        </div>

                        <label htmlFor="address">Money Recept:</label><br />
                        <img src={user && user.moneyReceipt_pic} height='150' width="400"></img>


                    </div>

                </div>


            </div>
        )
    }
}

export default StudentDetails
